import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Input } from 'components/ui';
import useEnterSubmit from 'components/Login/hooks/useEnterSubmit';
import { InputProps } from 'components/ui/Input';

const licensePlateInputConfig = {
  type: 'text',
  maxLength: 50,
  spellCheck: false,
  autoCorrect: 'off',
  'data-layout': 'alternate',
  'data-keyboard-type': 'licensePlate',
  label: <FormattedMessage id="login.licensePlate" defaultMessage="License plate" />,
};

type LicensePlateInputProps = {
  value?: string;
  center?: boolean;
  canSubmit?: boolean;
  onSubmit?: () => void;
} & Omit<InputProps, 'value'>;

const LicensePlateInput: React.FC<LicensePlateInputProps> = ({
  value,
  error,
  center,
  onChange,
  onSubmit,
  canSubmit,
  className,
  labelClassName,
  'data-testid': dataTestId,
  ...rest
}) => {
  const handleKeyDown = useEnterSubmit(onSubmit, canSubmit);

  return (
    <Input
      value={value}
      error={error}
      center={center}
      onChange={onChange}
      className={className}
      data-testid={dataTestId}
      onKeyDown={handleKeyDown}
      labelClassName={labelClassName}
      {...licensePlateInputConfig}
      {...rest}
    />
  );
};

export default LicensePlateInput;